import React from 'react';

import { Row } from 'apps/auth/components/common/Layout/Row';

import { LimitBlock } from '../gaLimits/LimitBlock';

const DefaultLimits = (props) => {
    const { isShowLimitsButton = false, button } = props;
    return (
        <>
            <Row indent="adaptive-32-48">
                <LimitBlock
                    title={props.title}
                    progressWidth={props.progressWidth}
                    isExhaustedLimit={props.isExhaustedLimit}
                    currency={props.currency}
                    spendSum={props.spendSum}
                    spendText={props.spendText}
                    leftSum={props.leftSum}
                    leftText={props.leftText}
                    isLimitError={props.isLimitError}
                    limitErrorText={props.limitErrorText}
                />
            </Row>
            {isShowLimitsButton && button}
        </>
    );
};

export default DefaultLimits;
